import { Button, Col, Input, Row, Skeleton } from 'antd'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Curriculumcard from './curriculumcard/curriculumcard'
import { openNotificationWithIcon } from '../../../../utils/helper'
import { getCurriculums, getLevels } from '../../../../api/curriculum/curriculum'
import Addcurriculum from './addcurriculum/addcurriculum'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import useLanguages from '../../../../customhooks/languages/useLanguages'

const curriculaTypes = ['New From Codefunhouse', 'Suggested for you', 'Your Curriculums']

const Teachercurricula = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const { languages, loadingLanguages } = useLanguages()

	const [currentType, setCurrentType] = useState(curriculaTypes[0])
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState([])
	const [showAddCurriculum, setShowAddCurriculum] = useState(false)
	const [levels, setLevels] = useState([])
	const [loadingLevels, setLoadingLevels] = useState(false)

	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state


	const requestParams = useMemo(() => {
		return {
			createdBy: currentType === curriculaTypes[2] ? user?._id : undefined
		}

		// eslint-disable-next-line
	}, [currentType])

	const closeShowAddCurriculum = (reload?: boolean) => {
		setShowAddCurriculum(false)
		if (reload === true) {
			fetchCurriculums()
		}
	}

	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'My Curricula',
			}
		})

		// eslint-disable-next-line
	}, [])

	const fetchCurriculums = useCallback(
		async () => {
			try {
				setLoading(true)
				const res = await getCurriculums(requestParams)
				const { data } = res?.data
				setData(data)
				setLoading(false)
			} catch (error: any) {
				setLoading(false)
				if (error?.response) {
					openNotificationWithIcon('error', 'Get Curriculums', `${error?.response?.data?.message || 'Something went wrong'}`)
				} else {
					openNotificationWithIcon('error', 'Get Curriculums', 'Something went wrong')
				}
			}
		},
		[requestParams],
	)


	useEffect(() => {
		fetchCurriculums()

	}, [fetchCurriculums])



	const fetchLevels = async () => {
		try {
			setLoadingLevels(true)
			const res = await getLevels()
			const { data } = res.data
			setLevels(data)
			setLoadingLevels(false)
		} catch (error: any) {
			setLoadingLevels(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'Get Levels', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Get Levels', 'Something went wrong')
			}
		}
	}

	useEffect(() => {
		fetchLevels()

		// eslint-disable-next-line
	}, [])



	return (
		<div className='min-h-screen pr-10 mt-4'>
			<div className='flex items-center'>
				{
					curriculaTypes.map((item, index) => (
						<p className={`px-[1.5rem] py-4 mr-3 rounded-[1.1rem] cursor-pointer text-appcolorwhitefaintfive text-base custom-light-bg-linear
						${currentType === item ? 'custom-light-blue-bg-linear' : ''}
						`} key={`curricula-type-${item}`}
							onClick={() => {
								setCurrentType(item)
							}}
						>
							{item}
						</p>
					))
				}
			</div>

			<div className='mt-[1.8rem] flex justify-between items-center'>
				<div className='flex items-center px-2 rounded-lg bg-appcolorcream w-fit'>
					<img src="/img/vectors/search.svg" alt="search" />
					<Input
						size="small"
						placeholder='Search record'
						bordered={false}
						className="w-full mr-4 custom-search-record full-input"
						onChange={(e: any) => {
							console.log(e.target.value)
						}}
					/>
				</div>


				<div className='flex items-center'>
					<div className='rounded-xl bg-appcolorgreyfaint mr-[0.6rem] p-[0.5rem] mt-2'>
						<img src="/img/vectors/think.svg" alt="think" className='w-5 h-5 cursor-pointer' />
					</div>
					<Button
						className='custom-primary-two-btn extra-smaller-padding'
						onClick={() => {
							setShowAddCurriculum(true)
						}}
					>
						+ Add New
					</Button>
				</div>
			</div>

			<div className='flex items-center justify-between mt-4'>
				<div className='flex items-center'>
					<p className='mr-2 text-sm text-appcolorwhitefaintsix'>
						Filter by Language
					</p>

					<img src="/img/vectors/curriculumpy.svg" alt="curriculumpy" className='' />
				</div>

				<div className='flex items-center cursor-pointer'>
					<div className='rounded-xl bg-appcolorgreyfaint mr-[0.6rem] p-[0.5rem]'>
						<img src="/img/vectors/filter.svg" alt="think" className='w-5 h-5 cursor-pointer' />
					</div>

					<p className='mr-2 text-sm text-appcolorwhitefaintsix'>
						Filter
					</p>
				</div>
			</div>


			<div className='mt-2 border-t-[3px] border-appcolorwhitefaintseven pt-[1.8rem]'>
				<Row gutter={32}>
					{
						loading ?
							<>
								{
									[1, 2, 3, 4, 5].map((item) => (
										<Col xs={24} md={24} lg={8} key={`loading-curriculum-${item}`}>
											<Skeleton.Button
												active={true}
												size={'large'}
												shape={'square'}
												block={true}
												style={{
													height: '12.5rem',
													marginBottom: '1.8rem',
													borderRadius: '1rem',
													marginRight: '1rem'
												}}
											/>
										</Col>
									))
								}
							</>
							:
							<>
								{
									data.map((item: any) => (
										<Col xs={24} md={24} lg={8} key={item?._id}>
											<Curriculumcard
												item={item}
											/>
										</Col>
									))
								}
							</>
					}
				</Row>
			</div>

			{
				showAddCurriculum ?
					<Addcurriculum
						open={showAddCurriculum}
						closeModal={closeShowAddCurriculum}
						loadingLanguages={loadingLanguages}
						languages={languages}
						levels={levels}
						loadingLevels={loadingLevels}
					/>
					:
					null
			}
		</div>
	)
}

export default Teachercurricula